import React, { useState, useEffect } from 'react'
import { SubscriptionImport } from './Import'
import OrderListFilter from './OrderListFilter'

const { ListLayout, useDispatch, useSelector, useNavigate, useTranslation, parseLinkHeader, orderList } = SubscriptionImport

export default function OrderList() {
    const { t } = useTranslation()
    const dispatch = useDispatch()
    const navigate = useNavigate()

    const [loading, setLoading] = useState(true)
    const [tableLoading, setTableLoading] = useState(false)
    const [headerLink, setHeaderLink] = useState(null)
    const [pageable, setPageable] = useState({
        pageSize: 10,
        currentPage: 0,
        search: '',
        totalRecord: 0,
    })

    const orders = useSelector(state => state?.subscriptionOrderList?.data)

    const columnDefs = [
        {
            headerName: t('subscription.table_no'),
            field: 'fieldName',
            cellRenderer: params => `${(pageable?.currentPage * pageable?.pageSize) + (params.node.rowIndex + 1)}`,
            sortable: true,
            maxWidth: 70
        },
        {
            headerName: t('subscription.table_order_id'),
            field: 'custom_order_id',
            sortable: true,
            cellRenderer: params => params.data?.custom_order_id || '-'
        },
        {
            headerName: t('subscription.table_user_name'),
            field: 'user.name',
            sortable: true,
            cellRenderer: params => <div className='text-capitalize'>{params.data?.user?.name || '-'}</div>
        },
        {
            headerName: t('subscription.table_plan_name'),
            field: 'plan.plan_name',
            sortable: true,
            cellRenderer: params => params.data?.plan?.plan_name || '-'
        },
        {
            headerName: t('subscription.table_amount'),
            field: 'amount',
            sortable: true,
            cellRenderer: params => params.data?.amount ? `₹${(params.data.amount / 100).toLocaleString()}` : '-'
        },
        {
            headerName: t('subscription.table_payment_status'),
            field: 'order_status',
            cellRenderer: params => <span className={`badge text-bg-${params?.value === 'success' ? 'success' : params?.value === 'pending' ? 'warning' : 'danger'}`}>{params.value || '-'}</span>,
            sortable: true,
        },
    ]

    const perPage = (val) => updatePageable({ pageSize: val, currentPage: 0 })
    const goToPage = (page) => updatePageable({ currentPage: page })

    const updatePageable = (updates) => {
        setTableLoading(true);
        const newPageable = { ...pageable, ...updates };
        setPageable(newPageable);
        dispatch(orderList({ pageable: newPageable, navigate })).then(res => handleResponse(res.payload))
    }

    const handleResponse = (res) => {
        if (res?.status === 200) {
            const parsed = parseLinkHeader(res.headers.link)
            setHeaderLink(parsed)
            setPageable(prev => ({
                ...prev,
                pageSize: parseInt(res.headers.get('x-page-limit'), 10),
                currentPage: parseInt(res.headers.get('x-current-page'), 10),
                totalRecord: parseInt(res.headers.get('x-Total-Count'), 10),
            }))
        }
        setTableLoading(false)
        setLoading(false)
    }

    useEffect(() => {
        setLoading(true)
        dispatch(orderList({ pageable, navigate })).then(res => handleResponse(res.payload))
    }, [])

    const [showFilter, setShowFilter] = useState(false)
    const handleShow = () => setShowFilter(true)

    return (
        <div className="container-fluid">
            <ListLayout
                showHeader
                title={t('subscription.order_list')}
                loading={loading}
                rowData={orders}
                columnDefs={columnDefs}
                tableLoading={tableLoading}
                showAdd={false}
                showSearch
                onFilter={() => handleShow()}
                height={'70vh'}
                showPagination
                pageable={{
                    pageSize: pageable?.pageSize,
                    currentPage: pageable?.currentPage,
                    totalRecord: pageable?.totalRecord,
                    perPage: (e) => perPage(e.target.value),
                    goToPage: (page) => goToPage(page),
                }}
                headerLink={headerLink}
            />
            <OrderListFilter
                show={showFilter}
                onHide={() => setShowFilter(false)}
                setTableLoading={setTableLoading}
                setPageable={setPageable}
                pageable={pageable}
                setHeaderLink={setHeaderLink}
            />
        </div>
    )
}

